import { AfterViewInit, OnDestroy, ViewChild, ElementRef as RouteElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { LoginRouteTransition } from 'ZalamoLibrary/src/lib/core/helpers/login-route-transition';
import {
  Component,
  ElementRef,
  ViewContainerRef,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AppComponent implements AfterViewInit, OnDestroy {
  @ViewChild('routeContainer', { static: true }) private routeContainer: RouteElementRef<HTMLElement>;
  private routeTransition: LoginRouteTransition;
  ngAfterViewInit(): void { this.routeTransition = new LoginRouteTransition(this.router, this.routeContainer.nativeElement); }
  ngOnDestroy(): void { this.routeTransition.destroy(); }

  constructor(public viewContainerRef: ViewContainerRef, private router: Router) {}


}
